import { Injectable } from '@angular/core';

import { Platform } from '@model/platform.model';
import { ScoopfreeActivityType } from '@model/product/scoopfree/activity/scoopfree-activity-type.model';

/**
 * PlatformService
 *
 * @export PlatformService
 */
@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  /**
   * platforms array
   */
  private platforms: Array<Platform> = [
    {
      name: 'SmartFeed',
      id: 'smartfeed',
      image: 'smartfeed.webp',
      activityTypes: [
        ScoopfreeActivityType.SHOW_ALL,
        ScoopfreeActivityType.DISCONNECT,
        ScoopfreeActivityType.ERROR,
        ScoopfreeActivityType.MEALS,
        ScoopfreeActivityType.FOOD_STATUS,
        ScoopfreeActivityType.CUST_VIEW,
      ],
    },
    {
      name: 'SmartFeed 2',
      id: 'smartfeed2',
      image: 'smartfeed.webp',
      activityTypes: [
        ScoopfreeActivityType.SHOW_ALL,
        ScoopfreeActivityType.DISCONNECT,
        ScoopfreeActivityType.ERROR,
        ScoopfreeActivityType.MEALS,
        ScoopfreeActivityType.FOOD_STATUS,
        ScoopfreeActivityType.CUST_VIEW,
      ],
    },
    {
      name: 'ScoopFree 2.0',
      id: 'scoopfree2',
      image: 'scoopfree.webp',
      activityTypes: [
        ScoopfreeActivityType.SHOW_ALL,
        ScoopfreeActivityType.ONLINE,
        ScoopfreeActivityType.RAKE_NOW,
        ScoopfreeActivityType.RAKE_MOVING_FORWARD,
        ScoopfreeActivityType.RAKE_STOPPED,
        ScoopfreeActivityType.REVERSE_RAKE,
        ScoopfreeActivityType.RAKE_MOVING_BACK,
        ScoopfreeActivityType.RAKE_FINISHED,
        ScoopfreeActivityType.REBOOTING,
        ScoopfreeActivityType.RESET_TO_FACTORY_DEFAULTS,
        ScoopfreeActivityType.LAST_WILL,
        ScoopfreeActivityType.RAKE_BUTTON_DETECTED,
        ScoopfreeActivityType.ERROR_RAKE_MOTOR_INTERRUPT,
        ScoopfreeActivityType.RAKE_PAUSED_MOTOR_CURRENT,
        ScoopfreeActivityType.RAKE_RESUME_MOTOR_CURRENT,
        ScoopfreeActivityType.CAT_IN_BOX,
        ScoopfreeActivityType.CAT_LEFT_BOX,
        ScoopfreeActivityType.RAKE_TIMER_EXPIRED,
        ScoopfreeActivityType.RAKE_COUNTER_RESET,
        ScoopfreeActivityType.RAKE_PAUSED_MANUAL,
        ScoopfreeActivityType.RAKE_RESUME_MANUAL,
        ScoopfreeActivityType.RAKE_PAUSE_CAT_ENTERED_BOX,
        ScoopfreeActivityType.RAKE_RESUME_CAT_EXIT,
        ScoopfreeActivityType.FATAL_ERROR_MOTOR_SAFETY,
        ScoopfreeActivityType.RESET_WIFI_NETWORK,
      ],
    },
    {
      name: 'SmartDogTrainer',
      id: 'smartdogtrainer',
      image: null,
      activityTypes: [
        ScoopfreeActivityType.SHOW_ALL,
        ScoopfreeActivityType.DISCONNECT,
        ScoopfreeActivityType.ERROR,
        ScoopfreeActivityType.CUST_VIEW,
      ],
    },
    {
      name: 'SmartDoor',
      id: 'smartdoor',
      image: null,
      activityTypes: [
        ScoopfreeActivityType.SHOW_ALL,
        ScoopfreeActivityType.DISCONNECT,
        ScoopfreeActivityType.ERROR,
        ScoopfreeActivityType.CUST_VIEW,
        ScoopfreeActivityType.MOTION_DETECTED_INSIDE,
        ScoopfreeActivityType.MOTION_DETECTED_OUTSIDE,
        ScoopfreeActivityType.MOTION_ABSENT_OUTSIDE,
        ScoopfreeActivityType.MOTION_ABSENT_INSIDE,
        ScoopfreeActivityType.MOTION_ABSENT_OUTSIDE_FALSE_TRIGGER,
        ScoopfreeActivityType.MOTION_ABSENT_INSIDE_FALSE_TRIGGER,
        ScoopfreeActivityType.RFID_READ_INSIDE,
        ScoopfreeActivityType.RFID_READ_OUTSIDE,
        ScoopfreeActivityType.ACCESS_PERMISSION_LOOKUP,
        ScoopfreeActivityType.SCHEDULE_EVENT,
        ScoopfreeActivityType.OVERRIDE,
        ScoopfreeActivityType.UNKNOWN_RFID,
        ScoopfreeActivityType.SCHEDULES_NOT_FOUND,
        ScoopfreeActivityType.TIME_NOT_SET,
        ScoopfreeActivityType.NO_SCHEDULES_ATTACHED_TO_RFID,
        ScoopfreeActivityType.INVALID_SCHEDULE,
        ScoopfreeActivityType.LATCH_LOCKED,
        ScoopfreeActivityType.LATCH_UNLOCKED,
        ScoopfreeActivityType.LATCH_IN_ONLY,
        ScoopfreeActivityType.LATCH_OUT_ONLY,
        ScoopfreeActivityType.FLAP_SWING_IN,
        ScoopfreeActivityType.FLAP_SWING_OUT,
        ScoopfreeActivityType.FLAP_SWING_TIMEOUT,
        ScoopfreeActivityType.FLAP_CENTERED,
        ScoopfreeActivityType.PET_ENTERED,
        ScoopfreeActivityType.PET_EXITED,
        ScoopfreeActivityType.PET_FAILED_TO_TRANSIT_DOOR_RELOCKED,
        ScoopfreeActivityType.USER_MODE_CHANGE_SMART,
        ScoopfreeActivityType.USER_MODE_CHANGE_LOCKED,
        ScoopfreeActivityType.USER_MODE_CHANGE_UNLOCKED,
        ScoopfreeActivityType.USER_DISABLED_FRONT_PANEL,
        ScoopfreeActivityType.USER_WIFI_SOFT_REBOOT,
        ScoopfreeActivityType.USER_WIFI_PROVISIONING_RESET,
        ScoopfreeActivityType.USER_FACTORY_RESET,
        ScoopfreeActivityType.USER_BUTTONS_LOCKED_ENABLED,
        ScoopfreeActivityType.USER_BUTTONS_LOCKED_DISABLED,
        ScoopfreeActivityType.CLOUD_MODE_CHANGE_SMART,
        ScoopfreeActivityType.CLOUD_MODE_CHANGE_LOCKED,
        ScoopfreeActivityType.CLOUD_MODE_CHANGE_UNLOCKED,
        ScoopfreeActivityType.CLOUD_BUTTONS_LOCKED_ENABLED,
        ScoopfreeActivityType.CLOUD_BUTTONS_LOCKED_DISABLED,
        ScoopfreeActivityType.DISPLAY_ON,
        ScoopfreeActivityType.DISPLAY_OFF,
        ScoopfreeActivityType.ERROR_MOTOR_OVERCURRENT,
        ScoopfreeActivityType.ERROR_MOTOR_TIMEOUT,
        ScoopfreeActivityType.ERROR_FLAP_TIMEOUT,
        ScoopfreeActivityType.ERROR_FLAP_STUCK,
        ScoopfreeActivityType.ERROR_INSIDE_MOTION_SENSOR_CONTINUOUS,
        ScoopfreeActivityType.ERROR_OUTSIDE_MOTION_SENSOR_CONTINUOUS,
        ScoopfreeActivityType.ERROR_BUTTON_STUCK,
        ScoopfreeActivityType.ERROR_LATCH_POSITION_SENSOR,
        ScoopfreeActivityType.ERROR_VOLTAGE_READING_OUT_OF_RANGE,
        ScoopfreeActivityType.RTC_TIME_UPDATE,
        ScoopfreeActivityType.POWER_FAIL_MODE,
        ScoopfreeActivityType.BATTERY_LEVEL_THRESHOLD,
        ScoopfreeActivityType.POWER_AC_LOST,
        ScoopfreeActivityType.POWER_AC_RESTORED,
        ScoopfreeActivityType.POWER_AC_NO_BATTERIES,
        ScoopfreeActivityType.ENTERED_FINAL_ACT_STATE,
        ScoopfreeActivityType.OTA_WAITING_JOB_START,
        ScoopfreeActivityType.OTA_JOB_STARTED,
        ScoopfreeActivityType.OTA_BLOCK_RECEIVED,
        ScoopfreeActivityType.OTA_ALL_BLOCKS_RECEIVED,
        ScoopfreeActivityType.OTA_IMAGE_VERIFIED,
      ],
    },
    // {
    //   name: 'SmartTracker',
    //   id: 'futuredevice1',
    //   image: null,
    //   activityTypes: [
    //     ScoopfreeActivityType.SHOW_ALL,
    //     ScoopfreeActivityType.DISCONNECT,
    //     ScoopfreeActivityType.ERROR,
    //     ScoopfreeActivityType.CUST_VIEW
    //   ]
    // },
    // {
    //   name: 'Future Device 2',
    //   id: 'futuredevice2',
    //   image: null,
    //   activityTypes: [
    //     ScoopfreeActivityType.SHOW_ALL,
    //     ScoopfreeActivityType.DISCONNECT,
    //     ScoopfreeActivityType.ERROR,
    //     ScoopfreeActivityType.CUST_VIEW
    //   ]
    // }
  ];

  /**
   * Creates an instance of PlatformService.
   */
  constructor() {}

  /**
   * getPlatforms
   *
   * @returns an Array of all PetSafe platforms
   */
  getPlatforms(): Array<Platform> {
    return this.platforms;
  }

  /**
   * Selects a platform by it's id
   *
   * @param platformId used to select corrosponding platform
   * @returns corrosponding platform
   */
  getById(platformId: string): Platform {
    return this.platforms.find(p => p.id === platformId);
  }
}
